import ICampaign from '@/interfaces/ICampaign';
import IState from '@/interfaces/IState';
import router from '@/router';
import Vue from 'vue';
import {ActionContext} from 'vuex';

export default async (context: ActionContext<IState, IState>, payload: { createOnly: boolean, campaignData: ICampaign }) => {
    if (!payload.campaignData) {
        return Promise.reject('Incorrect campaign data');
    }

    const formAction = async () => {
        if(payload.createOnly) {
            await context.dispatch('campaignsList', {query: '?pagination=true&page=1'});
            router.push({name: 'subscription_campaigns_list'});
        } else {
            Vue.notify({
                group: 'notice',
                title: `Campaign`,
                text: 'Added Successfully',
                type: 'success'
            });
        }
    };

    try {
        const newCampaign = await context.dispatch('backendTalker', {
            request: 'subscriptions_campaign_create',
            data: payload.campaignData
        });
        if (newCampaign.status === 201) {
            await formAction();
        } else {
            return newCampaign.data;
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
